import { string } from 'prop-types';
import React from 'react';
import { Badge } from 'reactstrap';

import { STAGE_TO_COLOR_MAP } from '../constants';

function StageBadge({ stage }) {
  return (
    <Badge pill color={STAGE_TO_COLOR_MAP[stage]}>
      {stage}
    </Badge>
  );
}

StageBadge.propTypes = {
  stage: string.isRequired,
};

export default StageBadge;
